import { useTranslations } from '@/lib/next-shim'
import { Link } from '@/lib/i18n/settings'
import { MeetingLink } from '../api/getMeetingLink'

type HeroProps = {
  meetingLink: MeetingLink
  meetingLinkSlug: string
}

export function Hero({ meetingLink, meetingLinkSlug }: HeroProps) {
  const t = useTranslations()
  const creator = meetingLink.createdBy
  const isImmediateEnabled = meetingLink?.immediateConsultationConfig?.enabled && !!meetingLink?.waitingRoom

  return (
    <div className="bg-gradient-to-r from-primary to-primary-dark text-white">
      <div className="mx-auto max-w-7xl px-4 pt-10 pb-16 sm:px-6 lg:px-8">
        <div className="md:flex md:items-center md:justify-between">
          <div className="max-w-2xl">
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">{meetingLink.name}</h1>
            <p className="mt-3 text-lg">
              {t.rich('page.MeetingLink.subtitle', {
                // @ts-ignore
                link: () => (
                  <Link href={`/${creator.establishment?.slug}/${creator.slug}`} className="text-white font-medium hover:underline">
                    {`${creator.userInfo.name} ${creator.userInfo.surname}`}
                  </Link>
                ),
              })}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
